export default __webpack_public_path__ + "static/sidebar-dark-31c8d8258f6b8588f7ba91e12c5e994fb791a21a2e32ad493510e6f2776583cd.png";